var map = {
	"./car.png": 10677,
	"./clothing.png": 55611,
	"./donation.png": 90149,
	"./food.png": 87331,
	"./leisure.png": 6382,
	"./other.png": 68889,
	"./pets.png": 83629,
	"./pharma.png": 75796,
	"./public-transportation.png": 38145,
	"./super.png": 11838,
	"./tourism.png": 51340,
	"./tracking-categories-no-selection.svg": 80636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52079;